import React from "react";
import PropTypes from "prop-types";

// No Setlist stepper exists; this is the prototype's − N + control.
const HeadcountStepper = ({ value, onChange, disabled, compact, label }) => {
  const size = compact ? 28 : 32;
  const height = compact ? 32 : 36;
  const button = {
    width: size,
    height: height - 2,
    border: "none",
    background: "var(--sl-bg-primary)",
    cursor: disabled ? "default" : "pointer",
    color: "var(--sl-text-secondary)",
    fontSize: 16,
    padding: 0,
  };
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        border: "1px solid var(--sl-border-primary)",
        borderRadius: "var(--sl-radius-md)",
        boxShadow: compact ? undefined : "var(--sl-shadow-xs)",
        height,
        overflow: "hidden",
      }}
    >
      <button type="button" aria-label={`Fewer ${label}`} style={button} disabled={disabled} onClick={() => onChange(Math.max(1, value - 1))}>
        −
      </button>
      <span
        style={{
          width: size,
          textAlign: "center",
          fontWeight: 600,
          color: "var(--sl-text-primary)",
          borderLeft: compact ? undefined : "1px solid var(--sl-border-primary)",
          borderRight: compact ? undefined : "1px solid var(--sl-border-primary)",
          lineHeight: `${height - 2}px`,
        }}
      >
        {value}
      </span>
      <button type="button" aria-label={`More ${label}`} style={button} disabled={disabled} onClick={() => onChange(value + 1)}>
        +
      </button>
    </div>
  );
};

HeadcountStepper.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  compact: PropTypes.bool,
  label: PropTypes.string.isRequired,
};

export default HeadcountStepper;
